import { dialogTypes } from '@/contexts/JDialogContext';
import {
  JdialogFilterTitleStyled,
  JdialogStyled,
  JdialogTitleStyled,
} from './j-dialog.styled';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { IconSize } from '@constants';

import { IconButton, useTheme } from '@mui/material';

interface Props {
  open: boolean;
  children: React.ReactNode;
  title: string;
  onClose: () => void;
  type: dialogTypes;
}

const JDialog = ({ open, children, title, onClose, type }: Props) => {
  const theme = useTheme();
  return (
    <JdialogStyled
      open={open}
      onClose={onClose}
      type={type}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {type === 'basic' && (
        <JdialogTitleStyled variant="h2" id="alert-dialog-title">
          {title}
        </JdialogTitleStyled>
      )}

      {type === 'filter' && (
        <JdialogFilterTitleStyled variant="h4" id="alert-dialog-title">
          <IconButton data-qa="close-dialog-icon" onClick={onClose}>
            <XMarkIcon width={IconSize.md} color={theme.palette.dark.dark_3} />
          </IconButton>
          {title}
          <div></div>
        </JdialogFilterTitleStyled>
      )}
      <div>{children}</div>
    </JdialogStyled>
  );
};

export default JDialog;
